import React from "react";
import BulkAssignee from "modules/bulk_assignee/BulkAssignee";
import TicketingSettings from "./TicketingSettings";
import { Tab, Tabs } from "react-bootstrap";
import UpdateAssignee from "modules/bulk_assignee/UpdateAssignee";

function TicketConfigure() {
  return (
    <div className="card p-2">
      <Tabs
        variant="pills"
        defaultActiveKey="ticket_configure"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        <Tab
          eventKey="ticket_configure"
          title="Ticket Configure"
          className="border p-3"
        >
          <TicketingSettings />
        </Tab>
        <Tab
          eventKey="add_Assignee"
          title="Add Assignee"
          className="border p-3"
        >
          <BulkAssignee />
        </Tab>
        <Tab
          eventKey="update_assignee"
          title="Update Assignee"
          className="border p-3"
        >
          <UpdateAssignee />
        </Tab>
      </Tabs>
    </div>
  );
}

export default TicketConfigure;
